import {defineMessages} from 'react-intl';

export default defineMessages({
  text: {
    defaultMessage: 'In this Chapter, you will learn...',
    id: 'Player.ElementsDisplay.TableOfContentsElement.TableOfContentsListHeading.Text',
  },
});
